import { log } from '../../services/utils';

import { controller } from '../../contexts/AuthContext';

import { noraApiRequest } from '.';

export const getAppInfo = async () => {
	log( '* get app info' );
	const { data } = await noraApiRequest( {
		url: '/info',
		signal: controller.signal
	} );

	return data;
};

export const authenticate = async ( {
	userName,
	password
} ) => {
	log( '* authenticate' );
	const { data } = await noraApiRequest( {
		url: '/login/authenticate',
		params: {
			userName,
			password: btoa( password )
		},
		signal: controller.signal
	} );

	return data;
};

export const resendTwoAuthMethod = async ( id, method ) => {
	log( '* resend two auth method' );
	const { data } = await noraApiRequest( {
		url: `login/${ id }/resend2auth/${ method }`,
		signal: controller.signal
	} );

	return data;
};

export const twoFactorAuthenticate = async ( {
	code,
	userName
} ) => {
	log( '* two factor authenticate' );
	const { data } = await noraApiRequest( {
		url: '/login/phase2authenticate',
		params: {
			code,
			userName
		},
		signal: controller.signal
	} );

	return data;
};

export const resendAuthCode = async id => {
	log( '* resend authentication code' );
	const { data } = await noraApiRequest( {
		url: `/login/${ id }/resend2auth`,
		signal: controller.signal
	} );

	return data;
};

export const getUserProfile = async userID => {
	log( '* get user profile' );
	const { data } = await noraApiRequest( {
		url: `/users/${ userID }`,
		signal: controller.signal
	} );

	return data;
};

export const getPasswordResetCode = async ( { userName } ) => {
	log( '* get password reset code' );
	const response = await noraApiRequest( {
		url: '/login/forgotpass',
		params: { userName },
		signal: controller.signal
	} );

	return response;
};

export const resetPassword = async ( {
	penCode,
	password
} ) => {
	log( '* reset password' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: '/users/confirmpass',
		params: {
			penCode,
			password: btoa( password )
		},
		signal: controller.signal
	} );

	return response;
};
